/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ActionResourceService} from '@well/resource-services';

@Injectable({
  providedIn: 'root'
})
export class ActionListPageService {

  constructor(private actionResourceService: ActionResourceService) {
  }

  getActions(event: any, subscriptionTypeUuid: string): Observable<any> {
    return this.actionResourceService.findAllForSubscriptionType(subscriptionTypeUuid, event);
  }

}
